import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import { getBoxProductDataForBoxBuilderPopup } from 'swag-client-common/utils/product.utils';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { BOX_BUILDER_SELECT_PRODUCTS_DRAWER, SUPER_SPEED_BOX_TYPE_CHANGE_CONFIRMATION } from 'swag-client-common/constants';
import { saveCustomBoxInfo, saveEditedBoxItselfInfo, selectBackButton, setCustomBoxColor, uploadBoxLogo } from '../../../../../redux/box-builder/box-builder.actions';
import { STEPS } from '../../../../../redux/box-builder/box-builder.constants';
import { customBoxInfoValuesSelector, customBoxLogoLoadingSelector, isEditingBoxTypeBoxIdSelector, showSuperSpeedConfPopupSelector, uploadedCustomBoxLogoSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import { specialBoxProductsSelector } from '../../../../../redux/cart/cart.selectors';
import { CustomBoxSelectionComponent } from './custom-box-selection';
const mapStateToProps = createStructuredSelector({
  isBoxTypeEdit: isEditingBoxTypeBoxIdSelector,
  uploadedLogo: uploadedCustomBoxLogoSelector,
  selectedColor: createSelector(customBoxInfoValuesSelector, customBoxInfo => customBoxInfo === null || customBoxInfo === void 0 ? void 0 : customBoxInfo.color),
  selectedBoxData: createSelector(specialBoxProductsSelector, specialProducts => {
    const product = specialProducts.find(product => product.specialProductType === SPECIAL_PRODUCT_TYPES.CUSTOM_BOX);
    return getBoxProductDataForBoxBuilderPopup(product);
  }),
  isLoading: customBoxLogoLoadingSelector,
  showSuperSpeedConfPopup: showSuperSpeedConfPopupSelector
});
const mapDispatchToProps = dispatch => ({
  onNext: ({
    color,
    isEditMode,
    showSuperSpeedConfPopup
  }) => {
    dispatch(saveCustomBoxInfo({
      color
    }));
    if (isEditMode) {
      if (showSuperSpeedConfPopup) {
        dispatch(showPopup({
          popup: SUPER_SPEED_BOX_TYPE_CHANGE_CONFIRMATION
        }));
      } else {
        dispatch(saveEditedBoxItselfInfo());
      }
    } else {
      dispatch(showPopup({
        popup: BOX_BUILDER_SELECT_PRODUCTS_DRAWER
      }));
    }
  },
  onChangeColor: color => {
    dispatch(setCustomBoxColor(color));
  },
  uploadCustomBoxLogo: logo => {
    dispatch(uploadBoxLogo(logo));
  },
  onBackButton: () => {
    dispatch(selectBackButton(STEPS.CUSTOM_BOX_SELECTION));
  }
});
export const CustomBoxSelection = connect(mapStateToProps, mapDispatchToProps)(CustomBoxSelectionComponent);